import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import Button from '@dbk/ui-buttons';
import { H5, H3 } from '@dbk/ui-text';
import TextBadge from '@dbk/ui-text-badge';
import ForgotPassword from './forgot-password';
import VascoOTP from './vasco-otp';
import ChangePassword from '../../../../../../src/screens/change-password/change-password';
import ChangePasswordEcedentials from '../../../../../../src/screens/change-password/change-password-eCredentials';
import { SuccessIcon } from '../../../../../../src/components/common/icons/index';
import { PALETTE, FORGOT_PASSWORD_FLOW_STEPS } from '../../../../../../src/constants';
import Text from '@dbk/ui-text';


class ForgotPasswordModalContent extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            emailId: undefined,
            userIdEmpty: undefined,
        };
    }

    componentDidUpdate(previousProps, previousState) {
        // if (previousProps.forgotPassword.initiateResetPwdResultValid !== this.props.forgotPassword.initiateResetPwdResultValid) {
        //     this.setState({ showActivePage: FORGOT_PASSWORD_FLOW_STEPS[1]})
        // }
    }

    getStepsContent = (stepIndex) => {
        const { app : { config: { isAirLockUpgrade }}} = this.props;
        switch (stepIndex) {
        case FORGOT_PASSWORD_FLOW_STEPS[0]:
          return <ForgotPassword />;
        case FORGOT_PASSWORD_FLOW_STEPS[1]:
          return <VascoOTP />;
        case FORGOT_PASSWORD_FLOW_STEPS[2]:
          if(isAirLockUpgrade){
            return <ChangePasswordEcedentials />
          }
          return <ChangePassword />
        case FORGOT_PASSWORD_FLOW_STEPS[3]:
            return this.getPwdSuccessMessage();
        default:
          return 'unknown step';
       }
    }

    getPwdSuccessMessage = () => {
        const { i18n: { messages } } = this.props;
        return(
            <View >
                <H3 tabIndex={0} className="pad-top-bottom-10  ">
                    {messages['app.forgotPassword.success.msg']}
                    <SuccessIcon className="margin-left-20" color={PALETTE.successIcon} height={24} width={24}/>
                </H3>
                <H5 tabIndex={0} className="margin-top-30">
                     {messages['app.auth.changePasswordSuccess']}
                 </H5>
                 <Text size="large" tabIndex={0} className="margin-top-30">
                     {messages['app.reset.forgotPassword.successMsg']}
                 </Text>
                 <View className="text-center pad-top-70">
                    <Button fullWidth size='large'
                    onPress={this.props.navigateToLogin}  // calling parent function
                    >
                    {messages['app.auth.login']}
                    </Button>
                    </View>
            </View>
        )
    }

    render() {
        const { i18n: { messages }, forgotPassword: { showCurrentStep }} = this.props;

        return (
            <View className="forgot_password">
                <View className="section-padding section_one">
                    {/* <ForgotPassword /> */}
                    {this.getStepsContent(showCurrentStep)}
                </View>
                <View className="section-padding section_two">
                    <View className='numeric-title' tabIndex={0} aria-label={`Step1: ${messages['app.reset.forgotPassword.tempPwd']}`}>
                        <TextBadge value={1} size='medium' secondary={showCurrentStep === FORGOT_PASSWORD_FLOW_STEPS[0]} className="content__step1__badge__style" />
                        <H5 className="pad-top-2 margin-left-10  title-ff-display-steps">{messages['app.reset.forgotPassword.tempPwd']}</H5>
                    </View>
                    <View className='numeric-title' tabIndex={0} aria-label={`Step2: ${messages['app.auth.vasco.add.device.otp.title']}`}>
                        <TextBadge value={2} size='medium' secondary={showCurrentStep === FORGOT_PASSWORD_FLOW_STEPS[1]} className="content__step1__badge__style" />
                        <H5 className="pad-top-2 margin-left-10 title-ff-display-steps">{messages['app.auth.vasco.add.device.otp.title']}</H5>
                    </View>
                    <View className='numeric-title' tabIndex={0}  aria-label={`Step3: ${messages['app.reset.forgotPassword.createPwd']}`}>
                        <TextBadge value={3} size='medium' secondary={showCurrentStep === FORGOT_PASSWORD_FLOW_STEPS[2]} className="content__step1__badge__style" />
                        <H5 className="pad-top-2 margin-left-10 title-ff-display-steps">{messages['app.reset.forgotPassword.createPwd']}</H5>
                    </View>
                    <View className='numeric-title' tabIndex={0} aria-label={`Step4: ${messages['app.auth.login']}`}>
                        <TextBadge value={4} size='medium' secondary={showCurrentStep === FORGOT_PASSWORD_FLOW_STEPS[3]} className="content__step1__badge__style" />
                        <H5 className="pad-top-2 margin-left-10 title-ff-display-steps">{messages['app.auth.login']}</ H5>
                    </View>
                    <Text size="large" className="contact-rm-title" tabIndex={0}>
                        {messages['app.reset.forgotPassword.contactRM']}
                    </Text>
                </View>
            </View>
        );
    }
};

export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        forgotPassword: {
            showCurrentStep: true,
        },
        app: {
            config: {
                isAirLockUpgrade: true
            }
        }
    },
},
)(ForgotPasswordModalContent);

